import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { modalClasses } from './modal.classes';
import { useModalStyles } from './modal.styles';
export const ModalLargeOrMediumViewport = ({ isOpen, className, verticalPosition, styles, disableTransition = false, children, role, onClose, ...rest })=>{
    const css = useModalStyles({
        verticalPosition
    });
    const backdropSlotProps = {
        classes: {
            root: modalClasses.backdrop
        },
        style: styles?.backdrop,
        sx: css.backdrop,
        ...disableTransition && {
            transitionDuration: {
                enter: 0,
                exit: 0
            }
        }
    };
    const containerStyle = disableTransition ? {
        ...styles?.container,
        animation: 'none'
    } : styles?.container;
    return /*#__PURE__*/ _jsx(Modal, {
        ...rest,
        onClose: onClose,
        role: role ?? 'dialog',
        "aria-modal": "true",
        open: isOpen,
        className: className,
        slotProps: {
            root: {
                className: modalClasses.root
            },
            backdrop: backdropSlotProps,
            ...disableTransition && {
                transition: {
                    timeout: {
                        enter: 0,
                        exit: 0
                    }
                }
            }
        },
        style: styles?.root,
        css: css.root,
        children: /*#__PURE__*/ _jsx(Box, {
            className: modalClasses.container,
            style: containerStyle,
            children: children
        })
    });
};

//# sourceMappingURL=modalLargeOrMediumViewport.js.map